const resource = {
  "accept": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accept and continue"])},
  "agentAgreement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agent agreement"])},
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terms and Conditions of the 1win Cash Agent Network"])}
}
export default resource